// import 'mapbox.js';

import { CustomLegendLayer } from './CustomLegendLayer';
import Directions from './Directions';
import { Grayscale, grayscale } from './Grayscale';
import Maps from './Maps';
import ThematicLayer from './ThematicLayer';
import { D3Layer, GeoJSONLayer, ZoomLevel } from './VectorLayer';

L.VectorLayer = { D3Layer, GeoJSONLayer, ZoomLevel };
L.Directions = Directions;
L.Maps = Maps;
L.ThematicLayer = ThematicLayer;
L.TileLayer.Grayscale = Grayscale;
L.tileLayer.grayscale = grayscale;

export { Directions, Maps, ThematicLayer, D3Layer, GeoJSONLayer, ZoomLevel, CustomLegendLayer };
export default { Directions, Maps, ThematicLayer, D3Layer, GeoJSONLayer, ZoomLevel, CustomLegendLayer };



// WEBPACK FOOTER //
// ./src/scripts/layers/Leaflet/index.js